import type { DetailSectionProps } from "./types-detail-section";
import { useDetailSection } from "./use-detail-section";
import { DetailSectionView } from "./view-detail-section";

export function DetailSection({ children, ...props }: DetailSectionProps) {
  const vm = useDetailSection(props);

  return <DetailSectionView {...vm}>{children}</DetailSectionView>;
}

export type * from "./types-detail-section";
